import React from 'react';
export function StatisticsSection() {
  const stats = [{
    percentage: '87%',
    text: '"Finally slept past 3AM without waking up"'
  }, {
    percentage: '91%',
    text: '"Stopped feeling like a zombie at work"'
  }, {
    percentage: '84%',
    text: '"Mind actually shut off at bedtime"'
  }, {
    percentage: '79%',
    text: '"Woke up before the alarm—naturally"'
  }];
  return <div className="my-16 bg-gradient-to-br from-purple-50 to-indigo-50 rounded-2xl p-8 md:p-12 border border-purple-200" data-id="element-516">
      <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3 text-center" data-id="element-517">
        What Happened When 27,000 Women Tried LyraSleep:
      </h2>

      <div className="grid md:grid-cols-2 gap-6 mt-8" data-id="element-518">
        {stats.map((stat, index) => <div key={index} className="bg-white rounded-xl p-6 shadow-lg border border-purple-100" data-id="element-519">
            <div className="flex items-start gap-4" data-id="element-520">
              <div className="text-5xl font-bold text-purple-600 flex-shrink-0" data-id="element-521">
                {stat.percentage}
              </div>
              <div className="flex-1" data-id="element-522">
                <p className="text-lg text-gray-800 leading-relaxed" data-id="element-523">
                  {stat.text}
                </p>
              </div>
            </div>
          </div>)}
      </div>

      <p className="text-center text-sm text-gray-600 mt-8 italic" data-id="element-524">
        Based on self-reported surveys from 27,000+ verified customers
      </p>
    </div>;
}